import api from '../../../services/api/microfwk';

//ESTA FUNCION OBTIENE LOS BOOKMARKS DE LOS CARRUSELES DEL SERVICION CONTENTLIST
export const getBookmarks = async ({ contenidos, user_hash, filterlist }) => {
    //ID`S DE LOS CONTENIDOS
    const group_id = contenidos?.groups?.map(item => item?.id).join(',');
  
    //BOOKMARK DE LOS CONTENIDOS
    const bookmarkResponse = await api.get('services/user/getbookmark', {
      params: {
        api_version: 'v4',
        user_hash,
        group_id,
      },
    });
  
    let carouselResults;
    if (bookmarkResponse?.data?.response?.groups?.length) {
      carouselResults = contenidos?.groups?.map(item => {
        const hasBookmark = bookmarkResponse?.data?.response?.groups?.find(
          bookmarkItem => bookmarkItem?.id === item?.id,
        );
        if (hasBookmark) {
          return {
            ...item,
            bookmark: hasBookmark?.vistime,
          };
        } else {
          return item;
        }
      });
    } else {
      carouselResults = contenidos;
    }
  
    return {groups: carouselResults};
  };
  